module.exports = __webpack_public_path__ + "img/l2.264172da.svg";